import { Skeleton } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { FC, Fragment } from 'react';

import { UserAuthMenu } from '@/components/ui/shared/headers/CoreHeader/components/UserAuthMenu';
import { CoreNavigationAuthenticationDesktop } from '@/components/ui/shared/headers/CoreHeader/layouts/CoreNavigationAuthentication.desktop';
import { CoreNavigationAuthenticationMobile } from '@/components/ui/shared/headers/CoreHeader/layouts/CoreNavigationAuthentication.mobile';
import { AccessFrom } from '@/enums/AccessFrom';
import { sessionQueryOptions } from '@/queries/upgrade/sessions';

interface IUserMenuProps {
  onLogout: () => void;
  accessFrom: AccessFrom;
}

export const UserMenu: FC<IUserMenuProps> = ({ accessFrom, ...props }) => {
  const { data, isLoading } = useQuery(sessionQueryOptions());

  if (isLoading) {
    return <Skeleton w="32px" h="32px" borderRadius="full" ml={5} />;
  }

  if (!data) {
    return (
      <Fragment>
        <CoreNavigationAuthenticationDesktop accessFrom={accessFrom} display={{ base: 'none', lg: 'block' }} />
        <CoreNavigationAuthenticationMobile accessFrom={accessFrom} display={{ base: 'flex', lg: 'none' }} />
      </Fragment>
    );
  }

  return <UserAuthMenu accessFrom={accessFrom} user={data.user} {...props} />;
};
